import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MapService } from "../../map-page/map.service";
import { combineLatest, concat, forkJoin, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import * as mapboxgl from 'mapbox-gl';
import { GlobalDataService } from '../../../../shared-services/global-data.service';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-simple-map',
    templateUrl: './simple-map.component.html',
    styleUrls: ['./simple-map.component.scss']
})
export class SimpleMapComponent implements OnInit, AfterViewInit, OnChanges {

    constructor(private mapService: MapService, private globalDataService: GlobalDataService) {
    }

    @Input()
    center: [number, number];

    @Input()
    zoom: number;

    @Input()
    rotatingMarkerCoords: [number, number];

    @Input()
    currentRotation: number;

    @Input()
    generalMarkers: any[];

    @Input()
    mapStyle: string;

    @Output()
    clickPoint: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild("rotatingMarker")
    private rotatingMarkerImg: ElementRef;

    private rotatingMarkerInstance;

    private mapOptions = {};

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.mapOptions['container'] = 'simple-map';
        this.mapOptions['center'] = this.center;
        this.mapOptions['zoom'] = this.zoom;
        this.mapOptions['mapStyle'] = this.mapStyle ? this.mapStyle : 'mapbox://styles/mapbox/satellite-v9';
        const subscription = this.mapService.simpleMap(this.mapOptions)
            .pipe(
                mergeMap((map) => {
                    let markerOptions = {
                        map: map,
                        marker: this.rotatingMarkerCoords ? this.rotatingMarkerCoords : null,
                        element: this.rotatingMarkerCoords ? this.rotatingMarkerImg.nativeElement : null
                    };
                    return combineLatest(
                        of(map),
                        this.mapService.addMarker(markerOptions)
                    )
                })
            )
            .subscribe((mapAndMarker) => {
                if (this.rotatingMarkerCoords) {
                    this.rotatingMarkerInstance = mapAndMarker[1];
                    this.rotatingMarkerInstance.setRotation(this.currentRotation);
                }
                this.loadGeneralMarkers(mapAndMarker[0]);
                subscription.unsubscribe();
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.currentRotation && changes.currentRotation.currentValue != changes.currentRotation.previousValue && this.rotatingMarkerInstance && this.rotatingMarkerCoords) {
            this.rotatingMarkerInstance.setRotation(changes.currentRotation.currentValue);
        }

        if (changes.rotatingMarkerCoords && changes.rotatingMarkerCoords.currentValue != changes.rotatingMarkerCoords.previousValue && this.rotatingMarkerInstance) {
            this.rotatingMarkerInstance.setLngLat(changes.rotatingMarkerCoords.currentValue);
        }
    }

    private loadGeneralMarkers(map) {
        const markerObservables = [];
        this.generalMarkers = this.generalMarkers.map((markerOptions: any) => {
            markerOptions.map = map;
            return markerOptions;
        })
        this.generalMarkers.forEach((marker) => {
            this.createPopUp(marker);
            markerObservables.push(this.mapService.addMarker(marker));
        })
        const subscription = forkJoin(markerObservables)
            .subscribe(() => {
                subscription.unsubscribe();
            });
    }

    private createPopUp(marker) {
        // Create a popup, but don't add it to the map yet.
        var popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            className: "tooltipClass"
        });
        marker.element.addEventListener('mouseenter', (e) => {
            var coordinates = marker.marker;
            var description = "<div>" + this.globalDataService.getObjectTranslation(marker.data.tooltipTranslations, "name") + "</div>";
            popup.setLngLat(coordinates).setHTML(description).addTo(marker.map);
        })
        marker.element.addEventListener('click', (e) => {
            this.clickPoint.emit(marker.data);
        })

        marker.element.addEventListener('mouseleave', function (e) {
            popup.remove();
        })
    }


}
